/* PASEO — collection : filtres (taille/couleur/prix) + tri, tiroir bulles, instantané côté client */
(function () {
  var grid = document.getElementById('grid');
  if (!grid) return;
  var tiles = Array.prototype.slice.call(grid.querySelectorAll('.pcx'));
  if (!tiles.length) return;
  // mélange stable (seed fixe) pour ne pas grouper les couleurs d'un même produit
  function seededShuffle(arr, seed) {
    var a = arr.slice(), s = seed >>> 0;
    function rnd() { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }
  var original = seededShuffle(tiles, 20260721);
  original.forEach(function (t) { grid.appendChild(t); });
  // ordre réel « meilleures ventes » : rang serveur (collections triées best-selling)
  var byRank = tiles.slice().sort(function (a, b) {
    return (parseInt(a.dataset.rank, 10) || 9999) - (parseInt(b.dataset.rank, 10) || 9999);
  });
  // arrivée via le lien « Meilleures ventes » (méga-menu) → on affiche le vrai classement, pas le mélange
  var isBest = /(?:^|[?&])sort_by=best-selling(?:&|$)/.test(location.search);

  function hexOf(name) {
    var c = (name || '').toLowerCase().trim();
    if (/beige/.test(c)) return '#d8c6a8';
    if (/blanc|white|écru|ecru|crème|creme|ivoire/.test(c)) return '#f2efe8';
    if (/kaki|khaki/.test(c)) return '#7a7a52';
    if (/rose|pink/.test(c)) return '#e8b9c0';
    if (/marine|navy/.test(c)) return '#2c3550';
    if (/bleu|blue|levante|ciel|azul/.test(c)) return '#7ba3c9';
    if (/noir|black/.test(c)) return '#1a1a1a';
    if (/terra|brique|rouille/.test(c)) return '#8f4330';
    if (/\bor\b|gold|moutarde|jaune|yellow/.test(c)) return '#e8b84b';
    if (/vert|green|olive/.test(c)) return '#6b7a4a';
    if (/gris|grey|gray/.test(c)) return '#9a9a9a';
    if (/camel|caramel|cognac/.test(c)) return '#c19a6b';
    if (/corail|coral/.test(c)) return '#e5765f';
    if (/orange/.test(c)) return '#d98a4b';
    if (/marron|brun|brown|chocolat/.test(c)) return '#6b4a34';
    if (/bordeaux|bordo|wine/.test(c)) return '#6e2a2a';
    if (/lin|linen|sable|sand/.test(c)) return '#e2d3b3';
    if (/taupe/.test(c)) return '#b3a394';
    return '#cfc7ba';
  }

  // ---- construire les options depuis les vignettes ----
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'O/S', 'U', 'TU'];
  var sizesSet = {}, colorsSet = {}, prices = [];
  tiles.forEach(function (t) {
    (t.dataset.sizes || '').split(',').forEach(function (s) { s = s.trim(); if (s) sizesSet[s] = 1; });
    var c = (t.dataset.color || '').trim(); if (c) colorsSet[c] = 1;
    var p = parseFloat(t.dataset.price); if (!isNaN(p)) prices.push(p);
  });
  var sizes = Object.keys(sizesSet).sort(function (a, b) {
    var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
  });
  var colors = Object.keys(colorsSet);
  var PMIN = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0;
  var PMAX = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 100;
  if (PMIN === PMAX) PMAX = PMIN + 1;

  var F = { type: 'all', sizes: [], colors: [], sort: isBest ? 'best' : 'featured', pmin: PMIN, pmax: PMAX };

  // pills tailles
  var fpills = document.getElementById('fpills');
  if (fpills) fpills.innerHTML = sizes.map(function (s) { return '<button class="fpill" type="button" data-v="' + s + '">' + s + '</button>'; }).join('');
  // swatches couleurs
  var fsw = document.getElementById('fsw');
  if (fsw) fsw.innerHTML = colors.map(function (c) { return '<button class="fswb" type="button" data-v="' + c + '" style="background:' + hexOf(c) + '" title="' + c + '"></button>'; }).join('');
  // prix
  var prMin = document.getElementById('prMin'), prMax = document.getElementById('prMax');
  var pminlab = document.getElementById('pminlab'), pmaxlab = document.getElementById('pmaxlab');
  if (prMin && prMax) {
    [prMin, prMax].forEach(function (r) { r.min = PMIN; r.max = PMAX; });
    prMin.value = PMIN; prMax.value = PMAX;
  }
  function priceLabels() {
    if (pminlab) pminlab.textContent = F.pmin + ' €';
    if (pmaxlab) pmaxlab.textContent = F.pmax + ' €';
  }
  priceLabels();

  // ---- rendu ----
  var fcount = document.getElementById('fcount');
  var fbadge = document.getElementById('fbadge');
  var noresult = document.getElementById('noresult');

  function render() {
    var visible = 0;
    tiles.forEach(function (t) {
      var okType = F.type === 'all' || t.dataset.type === F.type;
      var tsizes = (t.dataset.sizes || '').split(',').map(function (s) { return s.trim(); });
      var okSize = !F.sizes.length || F.sizes.some(function (s) { return tsizes.indexOf(s) >= 0; });
      var okColor = !F.colors.length || F.colors.indexOf((t.dataset.color || '').trim()) >= 0;
      var p = parseFloat(t.dataset.price);
      var okPrice = isNaN(p) || (p >= F.pmin && p <= F.pmax);
      var show = okType && okSize && okColor && okPrice;
      t.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    // tri
    var order;
    if (F.sort === 'pasc') { order = tiles.slice().sort(function (a, b) { return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); }); }
    else if (F.sort === 'pdesc') { order = tiles.slice().sort(function (a, b) { return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); }); }
    else if (F.sort === 'best') { order = byRank.slice(); }
    else { order = original.slice(); }
    order.forEach(function (t) { grid.appendChild(t); });

    if (fcount) fcount.textContent = visible + (visible > 1 ? ' produits' : ' produit');
    var n = F.sizes.length + F.colors.length + ((F.sort === 'pasc' || F.sort === 'pdesc') ? 1 : 0) + ((F.pmin > PMIN || F.pmax < PMAX) ? 1 : 0);
    if (fbadge) { fbadge.textContent = n; fbadge.hidden = n === 0; }
    if (noresult) noresult.hidden = visible !== 0;
  }
  render();

  // ---- onglets ----
  document.querySelectorAll('.ctab').forEach(function (tab) {
    tab.onclick = function () {
      document.querySelectorAll('.ctab').forEach(function (x) { x.classList.remove('on'); });
      tab.classList.add('on');
      F.type = tab.dataset.type;
      render();
    };
  });

  // onglet actif depuis l'URL ?type=<tag> (sous-catégorie du méga-menu)
  (function () {
    var tg = (new URLSearchParams(location.search).get('type') || '').toLowerCase().trim();
    if (!tg) return;
    var tab = document.querySelector('.ctab[data-tag="' + tg + '"]');
    if (!tab) return;
    document.querySelectorAll('.ctab').forEach(function (x) { x.classList.remove('on'); });
    tab.classList.add('on');
    F.type = tab.dataset.type;
    render();
  })();

  // ---- tiroir ----
  var panel = document.getElementById('fpanelw'), ov = document.getElementById('foverlay');
  var fopen = document.getElementById('fopen');
  function openF() { if (panel) panel.classList.add('on'); if (ov) ov.classList.add('on'); }
  function closeF() { if (panel) panel.classList.remove('on'); if (ov) ov.classList.remove('on'); }
  if (fopen) fopen.onclick = openF;
  if (ov) ov.onclick = closeF;
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });

  // pills / swatches toggles (état local, appliqué au clic "Appliquer")
  var pendSizes = [], pendColors = [];
  if (fpills) fpills.querySelectorAll('.fpill').forEach(function (b) {
    b.onclick = function () {
      b.classList.toggle('on');
      var v = b.dataset.v, i = pendSizes.indexOf(v);
      if (i >= 0) pendSizes.splice(i, 1); else pendSizes.push(v);
    };
  });
  if (fsw) fsw.querySelectorAll('.fswb').forEach(function (b) {
    b.onclick = function () {
      b.classList.toggle('on');
      var v = b.dataset.v, i = pendColors.indexOf(v);
      if (i >= 0) pendColors.splice(i, 1); else pendColors.push(v);
    };
  });

  // curseur prix (double)
  function clampPrice() {
    if (!prMin || !prMax) return;
    var a = parseInt(prMin.value, 10), b = parseInt(prMax.value, 10);
    if (a > b) { var t = a; a = b; b = t; }
    F.pmin = a; F.pmax = b; priceLabels();
  }
  if (prMin) prMin.oninput = clampPrice;
  if (prMax) prMax.oninput = clampPrice;

  var fapply = document.getElementById('fapply');
  if (fapply) fapply.onclick = function () {
    F.sizes = pendSizes.slice();
    F.colors = pendColors.slice();
    var s = panel.querySelector('input[name=fsort]:checked');
    F.sort = s ? s.value : 'best';
    render(); closeF();
  };
  var freset = document.getElementById('freset');
  if (freset) freset.onclick = function () {
    pendSizes = []; pendColors = [];
    if (fpills) fpills.querySelectorAll('.on').forEach(function (x) { x.classList.remove('on'); });
    if (fsw) fsw.querySelectorAll('.on').forEach(function (x) { x.classList.remove('on'); });
    var b = panel.querySelector('input[name=fsort][value=best]'); if (b) b.checked = true;
    if (prMin) prMin.value = PMIN; if (prMax) prMax.value = PMAX;
    F = { type: F.type, sizes: [], colors: [], sort: 'best', pmin: PMIN, pmax: PMAX };
    priceLabels(); render();
  };

  if (window.paseoObserveReveals) window.paseoObserveReveals(grid);
})();
